export default {"src":"/_next/static/media/face-recognition.02430469.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};